import {ControlUpdater} from '../../dynamic-field/control-updater.type';
import {FieldConfig} from '../../dynamic-field/field.config';
import {isCommonValidatorsChanged, updateCommonFields} from '../../dynamic-field/default-control-updater';
import {buildCheckboxFieldValidators} from './checkbox-field.builder';
import {CheckboxFieldConfig} from './checkbox-field.config';

export const checkboxFieldControlUpdater: ControlUpdater = (
    currentFieldConfig: FieldConfig<any>,
    updateFieldConfig: FieldConfig<any>,
    control
) => {
    updateCommonFields(currentFieldConfig, updateFieldConfig, control);

    if (isCommonValidatorsChanged(currentFieldConfig, updateFieldConfig)) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};

        const validators = buildCheckboxFieldValidators(updatedFieldConfig);
        control.setValidators(validators);
        control.updateValueAndValidity({emitEvent: false});

        return;
    }

    if (updateFieldConfig.hasOwnProperty('required')
        && (currentFieldConfig as CheckboxFieldConfig).required !== (updateFieldConfig as CheckboxFieldConfig).required
    ) {
        const updatedFieldConfig = {...currentFieldConfig, ...updateFieldConfig};
        const validators = buildCheckboxFieldValidators(updatedFieldConfig);
        control.setValidators(validators);

        return;
    }
};
